import { getResource } from "./request";

const endpoint = "proposal/GetProposals";

export async function getAllProposals(data: ProposalFormType) {
  if (data.is_challenge_proposal === undefined) {
    delete data.is_challenge_proposal;
  }

  if (data.proposal_name === "") {
    delete data.proposal_name;
  }
  const { response, error, code } = await getResource({ endpoint, data });

  return { response, error, code };
}

export async function getSingleProposal(data: SingleProposalFormType) {
  const { response, error, code } = await getResource({
    endpoint: "proposal/GetProposal",
    data,
  });
  return { response, error, code };
}

export interface ProposalCardType {
  proposal_id: number;
  fund_id: number;
  user_id: number;
  challenge_id: number;
  proposal_description: string;
  proposal_name: string;
  amount_requested: number;
  rating: number;
  no_assessments: number;
  url: string;
  user_name: string;
  funded_status: boolean;
  result_votes: number;
  challenge_name: string;
  fund_name: number;
  fund_budget: number;
  ranking: number;
  received_percentage: number;
  yes_votes: number;
  no_votes: number;
  is_challenge_proposal: string;
  sponsored_by_leftovers: boolean;
}

export interface ProposalCardSummaryType {
  number_of_rows: number;
  items: ProposalCardType[];
}

export interface ProposalFormType {
  fund_id?: number[] | "All";
  challenge_id?: number[] | "All";
  num_per_page: number;
  page_number: number;
  amount_requested?: string;
  proposal_name?: string;
  funded_status?: boolean | "All";
  rating?: number;
  order_by?: string;
  ordering?: "asc" | "desc";
  user_id?: number;
  is_challenge_proposal?: boolean;
}

export interface SingleProposalFormType {
  proposal_id: number;
}

export interface SingleProposalType {
  amount_requested: number;
  challenge_id: number;
  experience: string;
  fund_id: number;
  no_assessments: number;
  proposal_id: number;
  rating: number;
  solution: string;
  url: string;
  user_id: number;
  proposal_description: string;
  is_challenge_proposal: boolean;
  proposal_name: string;
  fund_depletion: number;
  meets_approval_threshold: boolean;
  reason_not_funded: string;
  funded_status: boolean;
  result_votes: number;
  yes_votes: number;
  no_votes: number;
  fund_name: string;
  challenge_name: string;
  user_name: string;
  project_info: SingleProposalInfoType;
  videos: any[];
  media: any[];
  assessments: ProposalAssessmentType[];
}

export interface reviewType {
  assessment_note: string;
  assessment_rating: number;
}
export interface SingleProposalInfoType {
  amount_distributed: number;
  amount_remaining: number;
  completed_date: string | null;
  evidence: string | null;
  expected_completion_date: string | null;
  final_report: string | null;
  final_video: string | null;
  notes: string;
  project_completed: boolean;
  project_id: number;
  project_on_track: boolean;
  project_status_description: string;
}

export interface ProposalAssessmentType {
  assessment_question_id: number;
  assessment_question_name: string;
  items: reviewType[];
}
